import { createTranslations } from '@npco/utils-translations'

export const basicDetailsListItemsTranslations = createTranslations({
  date: 'Date',
  transactionType: 'Transaction type',
  status: 'Status',
  transactionReferenceNumber: 'Transaction Reference Number',
})
